function courseListSelectContinuar() {
  document.querySelector('#selectContinuar').className = 'selected';
  document.querySelector('#selectIniciados').className = '';
  document.querySelector('#selectCompletados').className = '';

  if (document.querySelector('#learningPlanTab')) {
    document.querySelector('#learningPlanTab').className = '';
  }

  if (document.getElementById('learningPlanBlockWrapper')) {
    document.getElementById('learningPlanBlockWrapper').remove();
  }

  if (document.querySelector('.notWatchedCourses') != null) {
    document.querySelector('.notWatchedCourses').style.display = 'none';
  }

  if (document.querySelector('.finishedCourses .courseBlock') != null) {
    document.querySelector('.finishedCourses').style.display = 'none';
  }

  if (document.querySelector('.watchedCourses .courseBlock') != null) {
    document.querySelector('.watchedCourses').style.display = 'flex';
  }
}

function courseListSelectIniciados() {
  document.querySelector('#selectIniciados').className = 'selected';
  document.querySelector('#selectCompletados').className = '';
  document.querySelector('#selectContinuar').className = '';

  if (document.querySelector('#learningPlanTab')) {
    document.querySelector('#learningPlanTab').className = '';
  }

  if (document.getElementById('learningPlanBlockWrapper')) {
    document.getElementById('learningPlanBlockWrapper').remove();
  }

  if (document.querySelector('.notWatchedCourses') != null) {
    document.querySelector('.notWatchedCourses').style.display = 'flex';
  }

  if (document.querySelector('.finishedCourses .courseBlock') != null) {
    document.querySelector('.finishedCourses').style.display = 'none';
  }

  if (document.querySelector('.watchedCourses .courseBlock') != null) {
    document.querySelector('.watchedCourses').style.display = 'none';
  }
}

function courseListSelectCompletados() {
  document.querySelector('#selectCompletados').className = 'selected';
  document.querySelector('#selectIniciados').className = '';
  document.querySelector('#selectContinuar').className = '';

  if (document.querySelector('#learningPlanTab')) {
    document.querySelector('#learningPlanTab').className = '';
  }

  if (document.getElementById('learningPlanBlockWrapper')) {
    document.getElementById('learningPlanBlockWrapper').remove();
  }

  if (document.querySelector('.notWatchedCourses') != null) {
    document.querySelector('.notWatchedCourses').style.display = 'none';
  }

  if (document.querySelector('.finishedCourses .courseBlock') != null) {
    document.querySelector('.finishedCourses').style.display = 'flex';
  }

  if (document.querySelector('.watchedCourses .courseBlock') != null) {
    document.querySelector('.watchedCourses').style.display = 'none';
  }
}

if (window.location.pathname.includes('/apps/my/courses/')) {
  main();

  async function main() {
    if (window.coursesMainAlreadyRan === true) {
      return;
    }
    window.coursesMainAlreadyRan = true;

    await until(() => document.querySelector('.courseBlock'));

    if (!document.querySelector('.notWatchedCourses')) {
      var notWatBlock = document.createElement('div');
      notWatBlock.className = 'appendWrapper row notWatchedCourses';
      notWatBlock.innerHTML = "<div class='sortingWrapper' style='width:100%'><span class='sortingHeader'>Cursos no Iniciados:</span></div>";
      document.querySelector('#apCB').prepend(notWatBlock);
    }

    if (!document.querySelector('.finishedCourses')) {
      var finBlock = document.createElement('div');
      finBlock.className = 'appendWrapper row finishedCourses';
      finBlock.innerHTML = "<div class='sortingWrapper' style='width:100%'><span class='sortingHeader'>Cursos Completados:</span></div>";
      document.querySelector('#apCB').prepend(finBlock);
    }

    if (!document.querySelector('.watchedCourses')) {
      var watBlock = document.createElement('div');
      watBlock.className = 'appendWrapper row watchedCourses';
      watBlock.innerHTML = "<div class='sortingWrapper' style='width:100%'><span class='sortingHeader'>Continuar viendo:</span></div>";
      document.querySelector('#apCB').prepend(watBlock);
    }

    Array.prototype.forEach.call(document.querySelectorAll('.courseBlock'), function(node) {
      if (node.querySelector('.c_coml_info_v').innerText == 'finished' || node.querySelector('.c_coml_info_v').innerText == 'finalizado') {
        document.querySelector('.finishedCourses').append(node);
      } else {
        var progressArray = node.querySelector('.c_coml_info_v').innerText.split('/');

        if (parseInt(progressArray[0]) == parseInt(progressArray[1])) {
          document.querySelector('.notWatchedCourses').append(node);
        } else {
          document.querySelector('.watchedCourses').append(node);
        }
      }
    });

    if (!document.querySelector('.viewSelectorCoursesList')) {
      var viewSelector = document.createElement('div');
      viewSelector.className = 'viewSelectorCoursesList';
      viewSelector.innerHTML = "<button onClick='courseListSelectContinuar();' id='selectContinuar'><span>Continuar viendo</span></button>";
      viewSelector.innerHTML += "<button onClick='courseListSelectIniciados();' id='selectIniciados'><span>Cursos no Iniciados</span></button>";
      viewSelector.innerHTML += "<button onClick='courseListSelectCompletados();' id='selectCompletados'><span>Cursos Completados</span></button>";
      document.querySelector('#apCB').prepend(viewSelector);
    }

    if (typeof productsBlock != "undefined") {
      var learningPlansArray = [];
      if (Object.values(productsBlock).length) {
        Object.values(window.prForFilter).map((el) => {
          if (typeof el.learningPlanObject != "undefined") {
            if (el.learningPlanObject !== null) {
              learningPlansArray.push(el.learningPlanObject.title);
            }
          }
        });
      }

      if (learningPlansArray.length) {
        if (document.querySelector('.coursesLearningPlanMenuItem')) {
          document.querySelector('.coursesLearningPlanMenuItem').style.display = 'inline-block';
        }

        if (document.querySelector('.coursesLearningPlanMenuItemMobile')) {
          document.querySelector('.coursesLearningPlanMenuItemMobile').style.display = 'inline-block';
        }

        if (!document.querySelector('#learningPlanTab')) {
          let learningPlanListElement = document.createElement('button');
          learningPlanListElement.id = 'learningPlanTab';
          learningPlanListElement.setAttribute('onclick', 'window.learningPlanFiltering(this)');
          let learningPlanSpan = document.createElement('span');
          learningPlanSpan.innerText = 'Mis planes de aprendizaje';
          learningPlanListElement.append(learningPlanSpan);

          document.querySelector('.viewSelectorCoursesList').insertAdjacentElement("beforeend", learningPlanListElement);
        }

        if (document.querySelectorAll('[data-attr-learning-plan=""]').length) {
          document.querySelectorAll('[data-attr-learning-plan=""]').forEach(function(el) {
            el.remove();
          });
        }
      }
    }

    if (document.querySelector('.notWatchedCourses .courseBlock') == null) {
      if (document.querySelector('.notWatchedCourses')) {
        document.querySelector('.notWatchedCourses').remove();
      }
    }

    if (document.querySelector('.finishedCourses .courseBlock') == null) {
      if (document.querySelector('.finishedCourses')) {
        document.querySelector('.finishedCourses').remove();
      }
    }

    if (document.querySelector('.watchedCourses .courseBlock') == null) {
      if (document.querySelector('.watchedCourses')) {
        document.querySelector('.watchedCourses').remove();
      }
    }

    if (window.coursesSearch != "undefined") {
      window.coursesSearch.doneTyping = () => {
        var searchCounter = 0;

        var search = document.getElementsByClassName('coursesSearchElement')[0].value.trim().toLowerCase();

        if (search != '') {
          document.getElementsByClassName('coursesSearchClear')[0].style.visibility = 'visible';
        } else {
          document.getElementsByClassName('coursesSearchClear')[0].style.visibility = 'hidden';
        }

        if (search == '') {
          if (document.getElementById('coursesSearchError')) {
            document.getElementById('coursesSearchError').remove();
          }
        }

        document.querySelectorAll('.courseBlock').forEach(function(el) {
          if (search == '') {
            searchCounter++;
            el.style.display = 'block';
          } else {
            if (el.querySelector('.absoluteInfo h4')) {
              var elementTitle = el.querySelector('.absoluteInfo h4').innerText.toLowerCase();
            } else {
              var elementTitle = '';
            }

            if (el.querySelector('.absoluteInfo p.courseDescription')) {
              var elementDescription = el.querySelector('.absoluteInfo p.courseDescription').innerText.toLowerCase();
            } else {
              var elementDescription = '';
            }

            if (
              elementTitle.includes(search) ||
              elementDescription.includes(search) ||
              (courseSearchSimilar(
                elementTitle.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''),
                search.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '')
              ) > 40)
            ) {
              searchCounter++;
              el.style.display = 'block';
            } else {
              el.style.display = 'none';
            }
          }
        });

        if (searchCounter == 0) {
          if (!document.getElementById('coursesSearchError')) {
            document.getElementById('apCB').insertAdjacentHTML('beforeend', '<p id="coursesSearchError">No encontramos resultados para “' + search + '”</p>');
          }
        } else {
          if (document.getElementById('coursesSearchError')) {
            document.getElementById('coursesSearchError').remove();
          }
        }
      };
    }

    // The popup is intentionally scheduled only after the campus list
    // has finished its own rendering and custom setup.
    if (typeof window.gtScheduleLegacyCampusPopupWhenReady === 'function') {
      window.gtScheduleLegacyCampusPopupWhenReady();
    } else {
      window.gtLegacyCampusPopupPending = true;
    }
  }

  function courseSearchSimilar(a, b) {
    var equivalency = 0;
    var minLength = (a.length > b.length) ? b.length : a.length;
    var maxLength = (a.length < b.length) ? b.length : a.length;
    for (var i = 0; i < minLength; i++) {
      if (a[i] == b[i]) {
        equivalency++;
      }
    }

    var weight = equivalency / maxLength;
    return (weight * 100);
  }

  function until(condition) {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (condition()) {
          clearInterval(interval);
          resolve();
        }
      });
    });
  }
}

window.coursesRewriteFiltersForLearningPLans = (status) => {
  try {
    var allInstructors = [];
    var learnigPlanIds = [];

    if (typeof productsBlock != "undefined") {
      Object.values(productsBlock).map((singleProduct) => {
        if (status) {
          if (singleProduct?.learningPlanObject !== null) {
            learnigPlanIds.push(parseInt(singleProduct.id));
          }
        }
      });
    }

    if (typeof window.additionalCFields != "undefined") {
      Object.values(window.additionalCFields).map((singleProduct) => {
        if (status) {
          if (singleProduct?.instructors) {
            if (learnigPlanIds.includes(parseInt(singleProduct.product_id))) {
              var splitedInstructors = singleProduct.instructors;

              splitedInstructors.map((splitedInstructor) => {
                if (!allInstructors.includes(splitedInstructor)) {
                  allInstructors.push(splitedInstructor);
                }
              });
            }
          }
        } else {
          if (singleProduct?.instructors) {
            var splitedInstructors = singleProduct.instructors;

            splitedInstructors.map((splitedInstructor) => {
              if (!allInstructors.includes(splitedInstructor)) {
                allInstructors.push(splitedInstructor);
              }
            });
          }
        }
      });
    }

    if (allInstructors.length) {
      var instructorsSelect = '<option value="all">Instructor</option>';
      allInstructors.map((instructor) => {
        instructorsSelect += '<option value="' + instructor.replace(/"/g, '\\"') + '">' + instructor + '</option>';
      });

      document.querySelectorAll('.coursesCustomInstructorsSelect').forEach((categoryElement) => {
        categoryElement.innerHTML = instructorsSelect;
      });
    }
  } catch (e) {
    console.log('instructors filtering error: ' + e);
  }

  try {
    var allProductsTags = [];

    if (typeof productsBlock != "undefined") {
      Object.values(productsBlock).map((singleProduct) => {
        if (singleProduct?.tags) {
          if (status) {
            if (singleProduct?.learningPlanObject !== null) {
              var splitedTags = singleProduct.tags.split(',');

              splitedTags.map((splitedTag) => {
                if (!allProductsTags.includes(splitedTag)) {
                  allProductsTags.push(splitedTag);
                }
              });

              if (singleProduct?.id) {
                if (document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.id + '"])')) {
                  document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.id + '"])').setAttribute('data-course-categories', singleProduct.tags);
                }
              }
            }
          } else {
            var splitedTags = singleProduct.tags.split(',');

            splitedTags.map((splitedTag) => {
              if (!allProductsTags.includes(splitedTag)) {
                allProductsTags.push(splitedTag);
              }
            });

            if (singleProduct?.id) {
              if (document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.id + '"])')) {
                document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.id + '"])').setAttribute('data-course-categories', singleProduct.tags);
              }
            }
          }
        }
      });
    }

    if (allProductsTags.length) {
      if (document.querySelector('.coursesCustomCategorySelect')) {
        var categorySelect = '<option value="all">Categorías</option>';
        allProductsTags.map((category) => {
          categorySelect += '<option value="' + category.replace(/"/g, '\\"') + '">' + category + '</option>';
        });

        document.querySelectorAll('.coursesCustomCategorySelect').forEach((categoryElement) => {
          categoryElement.innerHTML = categorySelect;
        });
      }
    }
  } catch (e) {
    console.log('categories filtering error: ' + e);
  }
};

window.learningPlanFiltering = (el) => {
  document.querySelectorAll('.appendWrapper').forEach((el) => { el.style.display = "flex"; });
  document.querySelector('#selectContinuar').className = '';
  document.querySelector('#selectIniciados').className = '';
  document.querySelector('#selectCompletados').className = '';
  el.classList.add('selected');

  var learningPlansArray = [];
  if (Object.values(productsBlock).length) {
    Object.values(window.prForFilter).map((el) => {
      if (typeof el.learningPlanObject != "undefined") {
        if (el.learningPlanObject !== null) {
          learningPlansArray.push(el.learningPlanObject.title);
        }
      }
    });

    if (learningPlansArray.length) {
      var uniqArray = learningPlansArray.filter(function(value, index, array) { return array.indexOf(value) === index; });

      var createWrapperElement = document.createElement('div');
      createWrapperElement.id = 'learningPlanBlockWrapper';
      createWrapperElement.style.display = 'flex';
      createWrapperElement.classList = 'appendWrapper row';

      uniqArray.map((learningPlanName) => {
        if (document.querySelectorAll('.courseBlock[data-attr-learning-plan="' + learningPlanName + '"]').length) {
          var learningPlanTitle = document.createElement('div');
          learningPlanTitle.className = 'sortingWrapper';
          learningPlanTitle.style = 'display:block;width:100%;';
          var learningPlanTitleName = document.createElement('span');
          learningPlanTitleName.className = 'sortingHeader';
          learningPlanTitleName.innerText = learningPlanName;

          learningPlanTitle.append(learningPlanTitleName);
          createWrapperElement.append(learningPlanTitle);

          document.querySelectorAll('.courseBlock[data-attr-learning-plan="' + learningPlanName + '"]').forEach((learningPlanNode) => {
            let clonedDiv = learningPlanNode.cloneNode(true);
            createWrapperElement.append(clonedDiv);
          });
        }
      });

      if (document.getElementById('apCB')) {
        if (document.getElementById('learningPlanBlockWrapper')) {
          document.getElementById('learningPlanBlockWrapper').remove();
        }

        if (document.querySelectorAll('#apCB .appendWrapper').length) {
          document.querySelectorAll('#apCB .appendWrapper').forEach((el) => { el.style.display = 'none'; });
        }

        document.getElementById('apCB').insertAdjacentElement("beforeend", createWrapperElement);
      }

      window.coursesRewriteFiltersForLearningPLans(true);
    }
  }
};

async function getCoursesVimeoDuration(lesson_id, videoUrl) {
  var apiUrl = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(videoUrl)}`;
  var coursesSvgDurationIcon = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="vertical-align: sub; display: inline-block; margin-right: 3px;" fill="#69727b" height="15px" width="15px" version="1.1" id="Capa_1" viewBox="0 0 295 295" xml:space="preserve"> <g> <path d="M285.333,224.5H284V43.175c0-9.374-6.817-16.675-16.191-16.675H28.857C19.483,26.5,12,33.801,12,43.175V224.5h-1.667   C4.811,224.5,0,228.977,0,234.5v24c0,5.523,4.811,10,10.333,10h275c5.523,0,9.667-4.477,9.667-10v-24   C295,228.977,290.856,224.5,285.333,224.5z M42,56.5h212v165H42V56.5z M213.851,256.236c-5.18,0-9.38-4.199-9.38-9.38   c0-5.18,4.199-9.38,9.38-9.38c5.18,0,9.38,4.199,9.38,9.38C223.23,252.036,219.031,256.236,213.851,256.236z M248.763,256.236   c-5.18,0-9.38-4.199-9.38-9.38c0-5.18,4.199-9.38,9.38-9.38c5.18,0,9.38,4.199,9.38,9.38   C258.143,252.036,253.944,256.236,248.763,256.236z"/> <path d="M131.162,156.416c1.587,0,3.213-0.523,4.726-1.515l46.912-30.723c2.534-1.658,3.984-4.182,3.984-6.922   c0-2.741-1.455-5.265-3.988-6.923l-46.921-30.72c-1.513-0.99-3.127-1.513-4.712-1.513c-3.571,0-7.163,2.733-7.163,7.958v62.398   C124,153.683,127.592,156.416,131.162,156.416z"/> <path d="M206.453,170.5H88.356c-8.284,0-15,6.716-15,15s6.716,15,15,15h118.097c8.284,0,15-6.716,15-15   S214.737,170.5,206.453,170.5z"/> </g> </svg>';

  try {
    var response = await fetch(apiUrl);
    var data = await response.json();

    var duration = secondsToMinutesSeconds(data.duration);

    if (document.querySelector('ul li.list-group-item[data-attr-id="' + lesson_id + '"] .cLessonTitle')) {
      var trustedHTML = '<span class="coursesVideoDuration">' + coursesSvgDurationIcon + ' ' + duration + '</span>';
      document.querySelector('ul li.list-group-item[data-attr-id="' + lesson_id + '"] .cLessonTitle').insertAdjacentHTML('beforeend', trustedHTML);
    }

  } catch (error) {
    console.error("Error fetching Vimeo video data:", error);
  }
}

function secondsToMinutesSeconds(sec) {
  const minutes = Math.floor(sec / 60);
  const seconds = sec % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

window.addEventListener("onCoursesRendered", function() {
  if (window.coursesFiltersAlreadyInjected === true) {
    return;
  }
  window.coursesFiltersAlreadyInjected = true;

  document.querySelectorAll('.c_coml_info_v').forEach((progressElement) => {
    if ((progressElement.innerText == 'finalizado') || (progressElement.innerText == 'finished')) {
      var progressValue = 100;
    } else {
      var progressValue = 0;

      var splitedValue = progressElement.innerText.split('/');

      if (typeof splitedValue[1] != "undefined") {
        let current = parseInt(splitedValue[0].trim());
        let total = parseInt(splitedValue[1].trim());

        if (total > 0) {
          progressValue = Math.round(((total - current) * 100) / total);
        }
      }
    }

    if (progressValue > 0) {
      var progressHtml = '<div class="courseProgressWrapper"><progress max="100" value="' + progressValue + '"></progress><span class="courseProgressPercentage">' + progressValue + '% completo</span></div>';
    } else {
      var progressHtml = '<div class="courseProgressWrapper"><progress max="100" value="' + progressValue + '"></progress></div>';
    }

    var closestParent = progressElement.parentElement.parentElement.parentElement.querySelector('.courseComplTime');

    if (closestParent) {
      closestParent.insertAdjacentHTML('afterend', progressHtml);

      if (progressValue > 0) {
        if (closestParent.parentElement.parentElement.querySelector('button[onclick^="window.viewCourse"]')) {
          closestParent.parentElement.parentElement.querySelector('button[onclick^="window.viewCourse"]').style.display = 'none';
        }
      }
    } else {
      if (progressElement.parentElement.parentElement.parentElement.querySelector('.courseDescription')) {
        var closestDescSelector = progressElement.parentElement.parentElement.parentElement.querySelector('.courseDescription');
        closestDescSelector.insertAdjacentHTML('afterend', progressHtml);

        if (progressValue > 0) {
          if (closestDescSelector.parentElement.parentElement.querySelector('button[onclick^="window.viewCourse"]')) {
            closestDescSelector.parentElement.parentElement.querySelector('button[onclick^="window.viewCourse"]').style.display = 'none';
          }
        }
      }
    }
  });

  if (document.querySelector('#tagsFilter')) {
    document.querySelectorAll('.coursesProgressFilter').forEach((el) => el.remove());
    document.querySelectorAll('.coursesCustomInstructorsSelect').forEach((el) => el.remove());
    document.querySelectorAll('.coursesCustomCategorySelect').forEach((el) => el.remove());
    document.querySelectorAll('.allCoursesFiltersClearing').forEach((el) => el.remove());

    var progressFilter = '<select class="coursesProgressFilter" onChange="window.coursesCustomProgressFilter(this)"> <option value="all">Progreso</option> <option value="not-started">No Iniciado</option> <option value="in-progress">En Progreso</option> <option value="completed">Completado</option> </select><button class="allCoursesFiltersClearing" onclick="window.clearAllCoursesFilters()">Restablecer</button>';

    document.querySelector('#tagsFilter').insertAdjacentHTML("afterend", progressFilter);
    document.querySelector('.coursesMobileFilteringBody').insertAdjacentHTML("afterbegin", '<select class="coursesProgressFilter" onChange="window.coursesCustomProgressFilter(this)"> <option value="all">Progreso</option> <option value="not-started">No Iniciado</option> <option value="in-progress">En Progreso</option> <option value="completed">Completado</option> </select>');
  }

  try {
    var allInstructors = [];

    if (typeof window.additionalCFields != "undefined") {
      Object.values(window.additionalCFields).map((singleProduct) => {
        if (singleProduct?.instructors) {
          if (document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.product_id + '"]) .absoluteInfo .courseDescription')) {
            document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.product_id + '"]) .absoluteInfo .courseDescription').insertAdjacentHTML("afterend", '<p class="courseInstructorValue">' + singleProduct.instructors.join(',') + '</p>');
          }

          var splitedInstructors = singleProduct.instructors;

          splitedInstructors.map((splitedInstructor) => {
            if (!allInstructors.includes(splitedInstructor)) {
              allInstructors.push(splitedInstructor);
            }
          });

          if (singleProduct?.product_id) {
            if (document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.product_id + '"])')) {
              document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.product_id + '"])').setAttribute('data-course-instructors', singleProduct.instructors.join(','));
            }
          }
        } else {
          if (singleProduct?.product_id) {
            if (document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.product_id + '"])')) {
              document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.product_id + '"]) .absoluteInfo .courseDescription').insertAdjacentHTML("afterend", '<p class="courseInstructorValue"></p>');
            }
          }
        }
      });
    }

    if (allInstructors.length) {
      var instructorsSelect = '<select class="coursesCustomInstructorsSelect" onChange="window.coursesInstructorsCustomFiltering(this)"><option value="all">Instructor</option>';
      allInstructors.map((instructor) => {
        instructorsSelect += '<option value="' + instructor.replace(/"/g, '\\"') + '">' + instructor + '</option>';
      });
      instructorsSelect += '</select>';

      if (document.querySelector('#tagsFilter')) {
        document.querySelector('#tagsFilter').insertAdjacentHTML("afterend", instructorsSelect);
        document.querySelector('.coursesMobileFilteringBody').insertAdjacentHTML("afterbegin", instructorsSelect);
      }
    }
  } catch (e) {
    console.log('instructors filtering error: ' + e);
  }

  try {
    var allProductsTags = [];

    if (typeof productsBlock != "undefined") {
      Object.values(productsBlock).map((singleProduct) => {
        if (singleProduct?.tags) {
          var splitedTags = singleProduct.tags.split(',');

          splitedTags.map((splitedTag) => {
            if (!allProductsTags.includes(splitedTag)) {
              allProductsTags.push(splitedTag);
            }
          });

          if (singleProduct?.id) {
            if (document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.id + '"])')) {
              document.querySelector('.courseBlock:has(button[data-prod-id="' + singleProduct?.id + '"])').setAttribute('data-course-categories', singleProduct.tags);
            }
          }
        }
      });
    }

    if (allProductsTags.length) {
      var categorySelect = '<select class="coursesCustomCategorySelect" onChange="window.coursesCateroriesCustomFiltering(this)"><option value="all">Categorías</option>';
      allProductsTags.map((category) => {
        categorySelect += '<option value="' + category.replace(/"/g, '\\"') + '">' + category + '</option>';
      });
      categorySelect += '</select>';

      if (document.querySelector('#tagsFilter')) {
        document.querySelector('#tagsFilter').insertAdjacentHTML("afterend", categorySelect);
        document.querySelector('.coursesMobileFilteringBody').insertAdjacentHTML("afterbegin", categorySelect);
      }
    }
  } catch (e) {
    console.log('categories filtering error: ' + e);
  }
});

window.addEventListener("onLessonRendered", function() {
  if (typeof window.firstLessonRender == "undefined") {
    window.firstLessonRender = 1;

    if (typeof window.myres != "indefined") {
      var coursesVimeoRegex = /<iframe[^>]+src=['"](https?:\/\/player\.vimeo\.com\/video\/\d+(?:\?[^\s"'<>]*)?)['"][^>]*>/gi;

      window.myres.map((section) => {
        if (section?.lessons) {
          if (Object.values(section.lessons).length) {
            Object.values(section.lessons).map((lesson) => {
              let match;

              while ((match = coursesVimeoRegex.exec(lesson.html)) !== null) {
                if (typeof match[1] != "undefined") {
                  let video_url = match[1];
                  let tempUrl = new URL(video_url);
                  tempUrl.search = "";
                  video_url = tempUrl.toString();

                  getCoursesVimeoDuration(lesson.id, video_url);
                }
              }
            });
          }
        }
      });
    }
  }
});

/* G-TALENT CAMPUS MIGRATION POPUP START */
(function() {
  var CAMPUS_PATH = '/apps/my/courses/';
  var NEW_CAMPUS_URL = 'https://gtalent-campus.net/';
  var SESSION_KEY = 'gtCampusMigrationPopupClosedNov8';
  var END_DATE = new Date('2026-11-09T00:00:00-05:00');

  // Only customers tagged "campus-anterior" are eligible.
  // This value is injected by snippets/courses_script.liquid before this asset loads.
  if (window.gTalentLegacyCampusPopupEligible !== true) {
    return;
  }

  if (!window.location.pathname.includes(CAMPUS_PATH)) {
    return;
  }

  if (new Date() >= END_DATE) {
    return;
  }

  function wasClosedThisSession() {
    try {
      return window.sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function rememberClosed() {
    try {
      window.sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      // sessionStorage is optional; the popup can still close without it.
    }
  }

  function renderCampusMigrationPopup() {
    if (wasClosedThisSession() || !document.body || document.getElementById('gtCampusMigrationPopup')) {
      return;
    }

    // Prevent duplicate rendering if Courses Plus fires its render event more than once.
    if (window.gtCampusMigrationPopupRendered === true) {
      return;
    }
    window.gtCampusMigrationPopupRendered = true;

    // IMPORTANT: the backdrop is visual only. It NEVER captures clicks.
    // This keeps the campus fully usable behind the notice and avoids freezing the app.
    var backdrop = document.createElement('div');
    backdrop.id = 'gtCampusMigrationBackdrop';
    backdrop.className = 'gt-campus-migration-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');

    var popup = document.createElement('div');
    popup.id = 'gtCampusMigrationPopup';
    popup.className = 'gt-campus-migration-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-labelledby', 'gtCampusMigrationTitle');
    popup.setAttribute('aria-describedby', 'gtCampusMigrationDescription');

    popup.innerHTML = [
      '<button type="button" class="gt-campus-migration-close" id="gtCampusMigrationClose" aria-label="Cerrar aviso">&times;</button>',
      '<div class="gt-campus-migration-badge">Nuevo campus G-Talent</div>',
      '<h2 id="gtCampusMigrationTitle">Tienes más tiempo para migrar al nuevo campus</h2>',
      '<p class="gt-campus-migration-subtitle">Decidimos extender el acceso al campus anterior hasta el <strong>8 de noviembre</strong>.</p>',
      '<div id="gtCampusMigrationDescription">',
        '<p>A partir del <strong>9 de noviembre</strong>, tus formaciones estarán disponibles únicamente en el nuevo campus G-Talent.</p>',
        '<div class="gt-campus-migration-highlight"><strong>Tu progreso y certificados estarán en el nuevo campus.</strong><span>Ingresa con el mismo correo que usas actualmente en G-Talent para encontrar tu información migrada.</span></div>',
        '<p>Te recomendamos <strong>comenzar a usar el nuevo campus desde ahora</strong> para que tu experiencia no se vea afectada. Antes del cierre, aprovecha para terminar cualquier formación pendiente y descargar los certificados que quieras conservar.</p>',
      '</div>',
      '<div class="gt-campus-migration-actions">',
        '<a class="gt-campus-migration-primary" id="gtCampusMigrationNewCampus" href="' + NEW_CAMPUS_URL + '" target="_blank" rel="noopener noreferrer">Ir al nuevo campus</a>',
        '<button type="button" class="gt-campus-migration-secondary" id="gtCampusMigrationContinue">Continuar aquí</button>',
      '</div>'
    ].join('');

    document.body.appendChild(backdrop);
    document.body.appendChild(popup);

    var closeButton = popup.querySelector('#gtCampusMigrationClose');
    var continueButton = popup.querySelector('#gtCampusMigrationContinue');
    var newCampusLink = popup.querySelector('#gtCampusMigrationNewCampus');

    function removePopup() {
      rememberClosed();
      document.removeEventListener('keydown', handleEscapeKey);

      if (popup && popup.parentNode) {
        popup.parentNode.removeChild(popup);
      }

      if (backdrop && backdrop.parentNode) {
        backdrop.parentNode.removeChild(backdrop);
      }
    }

    function handleEscapeKey(event) {
      if (event.key === 'Escape') {
        removePopup();
      }
    }

    // Deliberately do not use preventDefault(), stopPropagation(), capture listeners,
    // body scroll locking, or document-wide click handlers. Courses Plus remains untouched.
    if (closeButton) {
      closeButton.addEventListener('click', removePopup);
    }

    if (continueButton) {
      continueButton.addEventListener('click', removePopup);
    }

    if (newCampusLink) {
      newCampusLink.addEventListener('click', function() {
        rememberClosed();
      });
    }

    document.addEventListener('keydown', handleEscapeKey);
  }

  function runWhenCampusIsInteractive(callback) {
    function waitForIdleTime() {
      // Two animation frames allow the browser to paint the completed campus first.
      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(function() {
          if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(function() {
              window.setTimeout(callback, 700);
            }, { timeout: 2500 });
          } else {
            window.setTimeout(callback, 1200);
          }
        });
      });
    }

    if (document.readyState === 'complete') {
      waitForIdleTime();
    } else {
      window.addEventListener('load', waitForIdleTime, { once: true });
    }
  }

  function schedulePopupWhenReady() {
    if (wasClosedThisSession() || window.gtCampusMigrationPopupScheduled === true) {
      return;
    }

    window.gtCampusMigrationPopupScheduled = true;

    runWhenCampusIsInteractive(function() {
      renderCampusMigrationPopup();
    });
  }

  // Expose a small hook that the existing campus code calls only after it finishes.
  window.gtScheduleLegacyCampusPopupWhenReady = schedulePopupWhenReady;

  // In case the campus completed before this block was initialized.
  if (window.gtLegacyCampusPopupPending === true) {
    window.gtLegacyCampusPopupPending = false;
    schedulePopupWhenReady();
  }

  // Course/lesson view: wait for the lesson to render, then wait for browser idle time.
  window.addEventListener('onLessonRendered', schedulePopupWhenReady, { once: true });
})();
/* G-TALENT CAMPUS MIGRATION POPUP END */
